module.exports = require("@tiptap/extension-table-cell");